import { Link } from 'react-router-dom';
import { Logo } from '@/components/ui/Logo';
import { externalLinks } from '@/config/links';

const columns = [
  {
    title: 'Services',
    links: [
      { to: '/services/3d-animation', label: '3D & Animation' },
      { to: '/services/cgi', label: 'CGI' },
      { to: '/services/vfx', label: 'VFX' },
      { to: '/services/game-development', label: 'Game Development' },
      { to: '/services/unreal-engine', label: 'Unreal Engine' },
    ],
  },
  {
    title: 'Products',
    links: [
      { to: '/cnc', label: 'KETIX3D CNC' },
      { to: '/floe-ai', label: 'FLOE AI' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About' },
      { to: '/work', label: 'Work' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms' },
      { to: '/delete-account', label: 'Delete Account' },
    ],
  },
];

export function Footer() {
  const socialEntries = [
    externalLinks.youtube && { label: 'YouTube', href: externalLinks.youtube },
    externalLinks.twitter && { label: 'X (Twitter)', href: externalLinks.twitter },
    externalLinks.instagram && { label: 'Instagram', href: externalLinks.instagram },
    externalLinks.linkedin && { label: 'LinkedIn', href: externalLinks.linkedin },
  ].filter(Boolean) as { label: string; href: string }[];

  return (
    <footer className="border-t border-line">
      <div className="container-page grid grid-cols-2 gap-10 py-16 md:grid-cols-6">
        <div className="col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-sm text-paper-500">
            Creative production and technology — 3D, animation, games, and the tools that build them.
          </p>
          {socialEntries.length > 0 && (
            <div className="mt-6 flex gap-4">
              {socialEntries.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-paper-500 hover:text-paper-100"
                >
                  {s.label}
                </a>
              ))}
            </div>
          )}
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <p className="eyebrow mb-4">{col.title}</p>
            <ul className="flex flex-col gap-2">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-paper-500 hover:text-paper-100">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-line py-6">
        <div className="container-page flex flex-col items-start justify-between gap-2 text-xs text-paper-500 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} KETIX3D. All rights reserved.</p>
          <p>Hyderabad · Building in public</p>
        </div>
      </div>
    </footer>
  );
}
